export const common = {
  // Header
  header_tagline: 'Your trusted IT partner since 2025',
  language_english: 'English',
  language_dutch: 'Nederlands',
  account: 'Account',
  cart: 'Cart',
  request_quote: 'Request Quote',
  
  // Navigation
  nav_hardware: 'Hardware',
  nav_software: 'Software',
  nav_it_services: 'IT Services',
  nav_it_solutions: 'IT Solutions',
  nav_generative_ai: 'Generative AI',
  nav_support: 'Support',
  nav_about: 'About',
  
  // Hardware Categories
  hardware_computing: 'Computing',
  hardware_networking: 'Networking',
  hardware_laptops_desktops: 'Laptops & Desktops',
  hardware_servers_storage: 'Servers & Storage',
  hardware_workstations: 'Workstations',
  hardware_components: 'Components',
  hardware_routers_switches: 'Routers & Switches',
  hardware_wireless_solutions: 'Wireless Solutions',
  hardware_security_appliances: 'Security Appliances',
  hardware_network_infrastructure: 'Network infrastructure',
  hardware_wifi_wireless: 'WiFi and wireless systems',
  hardware_network_security: 'Network security hardware',
  
  // Software Categories
  software_business: 'Business Software',
  software_security_utilities: 'Security & Utilities',
  software_microsoft_365: 'Microsoft 365',
  software_adobe_creative: 'Adobe Creative Cloud',
  software_accounting_erp: 'Accounting & ERP',
  software_antivirus: 'Antivirus & Security',
  software_backup: 'Backup Solutions',
  software_operating_systems: 'Operating Systems',
  
  // IT Services Categories
  services_core: 'Core Services',
  services_managed: 'Managed Services',
  services_integration: 'Integration & Configuration',
  services_cloud: 'Cloud Services',
  services_consulting: 'IT Consulting',
  services_project_management: 'Project Management',
  services_managed_it: 'Managed IT Services',
  
  // IT Solutions Categories
  solutions_enterprise: 'Enterprise Solutions',
  solutions_security: 'Security Solutions',
  solutions_enterprise_software: 'Enterprise Software Implementation',
  solutions_digital_transformation: 'Digital Transformation',
  solutions_infrastructure: 'Infrastructure Optimization',
  solutions_cyber_security: 'Cyber Security',
  
  // AI Categories
  ai_consulting: 'AI Consulting',
  ai_solutions: 'AI Solutions',
  ai_machine_learning: 'Machine Learning',
  ai_automation: 'AI Automation & Integration',
  ai_computer_vision: 'Computer Vision Solutions',
  ai_conversational: 'Conversational AI Systems',
  
  // Footer
  footer_quick_links: 'Quick Links',
  footer_products: 'Products',
  footer_services: 'Services',
  footer_company: 'Company',
  footer_legal: 'Legal',
  footer_newsletter: 'Newsletter',
  footer_newsletter_text: 'Stay updated with our latest products and services',
  footer_subscribe: 'Subscribe',
  footer_email_placeholder: 'Your email address',
  footer_contact: 'Contact',
  footer_phone: 'Phone',
  footer_email: 'Email',
  footer_address: 'Address',
  footer_rights: 'All rights reserved',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Service',
  footer_cookies: 'Cookie Policy',
  
  // Common Actions
  learn_more: 'Learn More',
  get_started: 'Get Started',
  contact_us: 'Contact Us',
  view_all: 'View All',
  read_more: 'Read More',
  submit: 'Submit',
  send: 'Send',
  close: 'Close',
  
  // Common Terms
  home: 'Home',
  products: 'Products',
  services: 'Services',
  solutions: 'Solutions',
  about: 'About',
  contact: 'Contact',
  careers: 'Careers',
  support: 'Support',
};

export default common;
